import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import {LabelText} from '../../Language/LabelText';
import './Logout.css';

export default function Logout(props) { 
    const logoutTooltip = 
    (  
      <Tooltip >
        <label><LabelText tid="logout" /></label>
      </Tooltip>     
    )

    const handlerOnLogoutClick = () => {     
      props.onLogoutClick(true);
    }

    return (  
    <>
     <OverlayTrigger placement="bottom" overlay={logoutTooltip} >
      <div role="button" title="Logout button" tabIndex="0" className="Logout" onClick={handlerOnLogoutClick}
            onKeyDown={(e)=>{ if (e.key === "Enter") handlerOnLogoutClick()}} />
     </OverlayTrigger>
    </>
   );
}

